import axios from "axios";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import checkImg from "./../../../Assets/Image/check.png";
import envelope from "./../../../Assets/Image/open-envelope-icon.jpg";
import loadingGid from "./../../../Assets/Image/LoadingSpin.gif";
import "./Register.css";
import SearchAutocomplete from "../../../components/SearchAutoComplete/SearchAutoComplete";
import { FaEnvelope, FaVoicemail } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./datepicker-custom.css";
import { useJsApiLoader } from "@react-google-maps/api";

const Register = (props) => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [dob, setDob] = useState();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [error, setError] = useState("");
  const [location, setLocation] = useState(null);
  const [countdown, setCountdown] = React.useState(3);
  const [approxLocation, setApproxLocation] = useState(null);

  const apiAddress = process.env.REACT_APP_SECRET;

  const [userNameFound, setUserNameFound] = useState(false);
  const [emailFound, setEmailFound] = useState(false);
  const [success, setSuccess] = useState(false);

  const { isLoaded: isGoogleLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: ["places"],
  });

  const isValidEmail = (value) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  };

  useEffect(() => {
    if (props.email && isValidEmail(props.email)) {
      setEmail(props.email);
    }
  }, [props.email]);

  useEffect(() => {
    if (!isGoogleLoaded) return;

    const fetchIpAndGeocode = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_SECRET}/api/Location/get-location-by-ipaddress-v2?ip=77.75.186.54`,
        );
        if (!res.ok) throw new Error("Failed to fetch IP location");

        const data = await res.json();
        if (!data.success) throw new Error("IP API failed");

        const lat = data.latitude;
        const lng = data.longitude;

        const approxLocation = {
          ip: data.ip,
          city: data.city,
          region: data.region,
          country: data.country,
          latitude: lat,
          longitude: lng,
        };

        console.log("Approx IP Location:", data);

        setApproxLocation(data);

        const geocoder = new window.google.maps.Geocoder();

        geocoder.geocode({ location: { lat, lng } }, (results, status) => {
          if (status === "OK" && results[0]) {
            const formattedAddress = results[0].formatted_address;

            const fullLocation = {
              ...approxLocation,
              address: formattedAddress,
            };

            setLocation(fullLocation);

            console.log("Reverse-geocoded address:", formattedAddress);
          } else {
            console.warn("Geocoder failed:", status);

            setLocation(approxLocation);
          }
        });
      } catch (err) {
        console.error(err.message);
      }
    };

    fetchIpAndGeocode();
  }, [isGoogleLoaded]);

  const handleChange = (event) => {
    const inputPhoneNumber = event.target.value;
    const numericPhoneNumber = inputPhoneNumber.replace(/\D/g, "");
    if (inputPhoneNumber !== numericPhoneNumber) {
      setError("Phone number must contain only numbers.");
    } else {
      setError("");
      if (numericPhoneNumber.length > 11) {
        setError("Please enter a valid 10 or 11 digit phone number.");
      } else {
        setPhoneNumber(numericPhoneNumber);
      }
    }
  };

  const handleChangePassword = (event) => {
    setPassword(event.target.value);
    if (confirmPassword) {
      if (event.target.value !== confirmPassword) {
        setError("Passwords do not match.");
      } else {
        setError("");
      }
    }
  };
  const handleChangeConfirmPassword = (event) => {
    setConfirmPassword(event.target.value);
    if (event.target.value !== password) {
      setError("Passwords do not match.");
    } else {
      setError("");
    }
  };

  const register = async (e) => {
    e.preventDefault();
    setLoading(true);
    // if (isValidPhoneNumber(phoneNumber)) {
    if (true) {
      if (password === confirmPassword) {
        if (password.length < 6) {
          setLoading(false);
          setError("Password must be at least 6 characters.");
        } else {
          // if (location) {
          if (true) {
            onSubmit();
          } else {
            toast.error("Please select a location.");
          }
        }
      } else {
        setLoading(false);
        setError("Passwords do not match.");
      }
    } else {
      setLoading(false);
      setError("Please enter a valid 10 or 11 digit phone number.");
    }
  };

  function generateUniqueAlphanumericUsername() {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let result = "";
    for (let i = 0; i < 9; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  }

  const onSubmit = () => {
    const uniqueUsername = generateUniqueAlphanumericUsername();
    const today = new Date().toISOString().split("T")[0];
    var url =
      apiAddress +
      "/api/GoTasteUser?password=" +
      password +
      "&returnUrl=" +
      window.location.href;
    var data = {
      id: "demo",
      firstName: firstname,
      lastName: lastname,
      dateOfBirth: today, //dob,
      currentBalance: 0,
      heldBalance: 0,
      userName: uniqueUsername, //username,
      email: email,
      emailConfirmed: false,
      phoneNumber: "00000000000", //phoneNumber,
      isActive: false,
      creationTimestamp: new Date(),
      // Default Manchester
      latitude: approxLocation.latitude, //location.latitude,
      longitude: approxLocation.longitude, //location.longitude,
      CityInformationId: "A47111FD-6536-4CBB-A106-1E8BEF4964F2", //location.id,
      cityInformation: {
        code: "N/A",
        countryName: approxLocation.country,
        cityName: approxLocation.city,
        latitude: approxLocation.latitude,
        longitude: approxLocation.longitude,
        iso2: approxLocation.country_code,
        iso3: "N/A",
        capital: approxLocation.capital,
        population: 0,
      },
    };
    axios({
      method: "post",
      url: url,
      data: data,
    })
      .then(function (response) {
        setLoading(false);
        console.log("res: " + response.data);
        if (response.data === "UserName Found") {
          setUserNameFound(true);
        } else if (response.data === "Email Found") {
          setEmailFound(true);
        } else if (response.data === "OK") {
          // toast.warn("Check your Inbox/spam folder to verify yourself");
          setSuccess(true);
          if (props.onRegisterSuccess) {
            props.onRegisterSuccess();
          }
          performLogin(uniqueUsername, password);
          const interval = setInterval(() => {
            setCountdown((prev) => {
              if (prev <= 1) {
                clearInterval(interval);
                // performLogin(uniqueUsername, password);
                window.location.reload();
                return 0;
              }
              return prev - 1;
            });
          }, 1000);

          // Cleanup interval if unmounted
          return () => clearInterval(interval);
        } else {
          toast.error(response.data, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        // window.location.href = "/";
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  };
  const isValidPhoneNumber = (phoneNumber) => {
    const phoneRegex = /^\d{10,11}$/;
    return phoneRegex.test(phoneNumber);
  };
  const [loading, setLoading] = useState(false);

  const performLogin = (username, password) => {
    var url =
      apiAddress +
      "/api/Login/loginAsync?userName=" +
      username +
      "&password=" +
      password;
    axios({
      method: "post",
      url: url,
    })
      .then(function (response) {
        console.log(response);
        console.log("Data: " + response.data.token);
        localStorage.setItem("gotasteClienttoken", response.data.token);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
        if (error.response.status == 404) {
          console.log(
            "error.response.data.status: " + error.response.data.status,
          );
          if (error.response.data.status == "Not activated") {
            toast.error("Not Activated", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          } else if (error.response.data.status == "Email not verified") {
            toast.error("Please verify your email", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
        }
      });
  };

  return (
    <div>
      <ToastContainer />
      <div className={`${success ? "d-none" : ""}`}>
        <form onSubmit={register}>
          <div className="container ">
            <h3 className="goTasteH3">Welcome To GoTaste</h3>
            <div className={"row mt-2 "}>
              {/* <div className='col-12'>
                                <span>First Name</span>
                            </div> */}
              <div className="col-12">
                <div className="form-group ">
                  <input
                    type="text"
                    className="form-control login-info"
                    placeholder="First Name"
                    value={firstname}
                    required
                    onChange={(event) => {
                      setFirstname(event.target.value);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className={"row mt-2 "}>
              {/* <div className='col-12'>
                                <span>Last Name</span>
                            </div> */}
              <div className="col-12">
                <div className="form-group ">
                  <input
                    type="text"
                    className="form-control login-info"
                    placeholder="Last Name"
                    value={lastname}
                    required
                    onChange={(event) => {
                      setLastname(event.target.value);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className={"row mt-2 "}>
              {/* <div className="col-12">
                <div className="form-group ">
                  <input
                    type='text'
                    className='form-control login-info'
                    placeholder='User Name'
                    value={username}
                    required
                    onChange={(event) => {
                      setUsername(event.target.value);
                      setUserNameFound(false);
                    }}
                  />
                  <span
                    className={`${userNameFound ? "" : "d-none"}`}
                    style={{ color: "red", fontSize: ".8rem" }}
                  >
                    {" "}
                    User Name Already exists *
                  </span>
                </div>
              </div> */}
            </div>
            {/* <div className={"row mt-2 "}>
              <div className="col-12">
                <div className="form-group ">
                  <DatePicker
                    selected={dob}
                    onChange={(date) => setDob(date)}
                    placeholderText="Date of Birth"
                    className="form-control login-info w-100"
                    dateFormat="dd-MM-yyyy"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    required
                    maxDate={new Date()} // Preventing future dates
                  />
                </div>
              </div>
            </div> */}
            {/* <div className={"row mt-2 "}>
              <div className="col-12">
                <div className="form-group ">
                  <input
                    type='tel'
                    className='form-control login-info'
                    placeholder='Phone Number'
                    value={phoneNumber}
                    required
                    onChange={(event) => {
                      handleChange(event);
                    }}
                  />
                </div>
              </div>
            </div> */}
            <div className={"row mt-2 "}>
              <div className="col-12">
                <div className="form-group ">
                  <input
                    type="email"
                    className="form-control login-info"
                    placeholder="Email"
                    value={email}
                    required
                    onChange={(event) => {
                      setEmail(event.target.value);
                      setEmailFound(false);
                    }}
                  />
                  <span
                    className={`${emailFound ? "" : "d-none"}`}
                    style={{ color: "red", fontSize: ".8rem" }}
                  >
                    {" "}
                    Email Already exists *
                  </span>
                </div>
              </div>
            </div>
            {/* <div className={"row mt-2 "}>
              <div className="col-12">
                <SearchAutocomplete
                  locationDataCallBack={(location) => {
                    setLocation(location);
                    console.log(location);
                  }}
                />
              </div>
            </div> */}

            <div className={"row mt-2 "}>
              {/* <div className='col-12'>
                                <span>Password</span>
                            </div> */}
              <div className="col-12">
                <div className="form-group ">
                  <input
                    type="password"
                    className="form-control login-info"
                    placeholder="Password"
                    value={password}
                    required
                    onChange={(event) => {
                      handleChangePassword(event);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className={"row mt-2 "}>
              <div className="col-12">
                <div className="form-group ">
                  <input
                    type="password"
                    className="form-control login-info"
                    placeholder="Confirm Password"
                    value={confirmPassword}
                    onChange={handleChangeConfirmPassword}
                    required
                  />
                </div>
              </div>
            </div>
            {error && <p className="error">{error}</p>}
            <div className={"row mt-2 "}>
              <div className="col-12">
                <span className="text-muted span-text">
                  We’ll call or text you to confirm your number. Standard
                  message and data rates apply. <b>Privacy Policy</b>
                </span>
              </div>
            </div>
            <div className={"row mt-4 "}>
              <div className="col-12 d-flex justify-content-center">
                {loading ? (
                  <button
                    className="btn btn-success font-weight-bold w-100 "
                    style={{
                      width: "    width: 100%;",
                      borderRadius: "8px",
                      backgroundColor: "#3D1E19",
                      pointerEvents: "none",
                    }}
                    type="submit"
                  >
                    <img src={loadingGid} alt="" style={{ width: "2rem" }} />
                  </button>
                ) : (
                  <button
                    className="btn btn-success font-weight-bold w-100 "
                    style={{
                      width: "    width: 100%;",
                      borderRadius: "8px",
                      backgroundColor: "#3D1E19",
                    }}
                    type="submit"
                  >
                    Register
                  </button>
                )}
              </div>
            </div>
          </div>
        </form>
      </div>

      <div className={`${success ? "" : "d-none"}`}>
        <div
          className="d-flex flex-column align-items-center text-center"
          style={{ gap: "12px" }}
        >
          <img src={checkImg} alt="Success" style={{ width: "5rem" }} />
          <h3 className="mt-2 mb-1">Successfully registered</h3>

          <div className="d-flex align-items-center" style={{ gap: "8px" }}>
            {/* <FaEnvelope size={28} /> */}
            {/* <p className="mb-0 ">
              Please check your email address to verify yourself
            </p> */}
            <p className="text-muted">
              Loggin in <strong>{countdown}</strong> seconds...
            </p>
          </div>

          {/* <p>Please check your email to verify yourself.</p> */}
        </div>
      </div>
    </div>
  );
};

export default Register;
